import ufeApi from 'services/api/ufeApi';

function getProductSamples(productId) {
    const url = `/api/v3/catalog/products/${productId}?productSamples=true`;

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getProductSamples;
